import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import PageContext from '../../../pages/PageContext';
import { ShipmentStatusIcon } from '../ShipmentStatus';
import {Heading} from '../../StyledComponents';
import './Tab.module.scss';

class Tab extends React.PureComponent {
  render() {
    const {
      title,
      icon,
      selected,
      onClick,
      designSettings: {
        bodyShipmentActiveTabColor,
        bodyShipmentInactiveTabColor,
        bodyTextColor: color,
        headingFontSize,
        headingFont,
        shipmentActiveIconColor,
        shipmentInactiveIconColor,
      },
    } = this.props;

    const tabBackgroundColor = selected ? bodyShipmentActiveTabColor : bodyShipmentInactiveTabColor ;
    const iconFill = selected ? shipmentActiveIconColor : shipmentInactiveIconColor;

    return (
      <PageContext.Consumer>
        { ({ isMobile }) => (
          <div
            styleName={classNames('tab', { selected, mobile: isMobile })}
            style={{backgroundColor : tabBackgroundColor}}
            onClick={onClick}
          >
            <span styleName="title">
              <Heading
                type="headingTertiary"
                fontSize={headingFontSize}
                font={headingFont}
                color={color}
                isMobile={isMobile}
              >
                {title}
              </Heading>
            </span>
            <span styleName="icon">
              <ShipmentStatusIcon
                name={icon}
                fill={ iconFill }
                size={ isMobile ? 16 : 32 }
              />
            </span>
          </div>
        )}
      </PageContext.Consumer>
    );
  }
}

Tab.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.string,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  designSettings: PropTypes.shape({
    headingFont:PropTypes.string,
    headingFontSize: PropTypes.string,
    bodyShipmentActiveTabColor: PropTypes.string,
    bodyTextColor: PropTypes.string,
    iconColor: PropTypes.string
  }),
};

export default Tab;


// WEBPACK FOOTER //
// ./src/js/widgets/Status/ShipmentTabs/Tab.js